/* import __COLOCATED_TEMPLATE__ from './preview.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();